import { Stack } from '../Stack';
import { Step } from './Step/Step';

import { StepsProps } from './Steps.types';
import './Steps.scss';

export const Steps = ({ steps }: StepsProps) => {
    return (
        <Stack direction="row">
            {steps.map((step, index) => (
                <Step key={index} step={step} />
            ))}
        </Stack>
    );
};
